import Grid from "@mui/material/Grid";
import BasePage from "../core/base.page";
import ProfileForm from "./profile.form";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      maxWidth: 500,
      margin: "0 auto",
      textAlign: "center",
      paddingBottom: 120,
      "&:after": {
        backgroundImage: "url(/cards.svg)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "70%",
        content: '""',
        display: "block",
        position: "absolute",
        width: "100%",
        height: "100%",
        filter: "opacity(0.1)",
        top: 0,
        left: 0,
        zIndex: -1,
      },
    },
  }),
);

export default function ProfilePage() {
  const classes = useStyles();
  return (
    <BasePage>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        width="100%"
        height="100%"
        className={classes.container}
      >
        <ProfileForm />
      </Grid>
    </BasePage>
  );
}
